import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    padding: "8px 16px",
    borderBottom: "1px solid rgb(206, 210, 214)",
  },
  header: {
    fontWeight: foundations.typography.fontWeight.medium,
    marginBottom: "4px",
  },
});
